class CardImageDots extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.closest('[data-card-media-wrapper]');
    this.track = this.wrapper ? this.wrapper.querySelector('[data-card-image-track]') : null;
    this.onDotClick = this.onDotClick.bind(this);
    this.addEventListener('click', this.onDotClick);
  }

  onDotClick(event) {
    const dot = event.target.closest('[data-dot-index]');
    if (!dot || !this.track) return;
    event.preventDefault();
    event.stopPropagation();

    const index = dot.dataset.dotIndex;

    this.querySelectorAll('[data-dot-index]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.dotIndex === index);
    });
    this.track.querySelectorAll('[data-dot-index]').forEach((el) => {
      el.classList.toggle('is-active', el.dataset.dotIndex === index);
    });
  }
}

if (!customElements.get('card-image-dots')) {
  customElements.define('card-image-dots', CardImageDots);
}
